import { render, staticRenderFns } from "./reportGeneral.vue?vue&type=template&id=a9999b90&scoped=true"
import script from "./reportGeneral.vue?vue&type=script&lang=js"
export * from "./reportGeneral.vue?vue&type=script&lang=js"
import style0 from "./reportGeneral.vue?vue&type=style&index=0&id=a9999b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9999b90",
  null
  
)

export default component.exports